import { createGlobalStyle } from "styled-components";

export const AppGlobalStyle = createGlobalStyle`
body,
html {
	font-family: var(--font-family);
	color: var(--color-text);
}

/* Headings join the weight scale.

   Nothing in the app declared a weight for h1-h6, so every heading was taking
   700 straight from the browser's UA stylesheet — outside the token scale, and
   untouched by the shift to lighter weights. That is what made the card titles,
   the project sidebar title and the BCF section title read heavier than
   everything around them.

   The weight is --font-weight-medium, not the emphasis weight: a heading is
   already set apart by its size and usually by its colour, so it does not need
   the heaviest step as well. Emphasis (--font-weight-bold) is for a 14px section
   heading that has no size to distinguish it — hds/SectionHeading declares that
   for itself, which is how any heading that wants a different weight says so. */
h1,
h2,
h3,
h4,
h5,
h6 {
	font-weight: var(--font-weight-medium);
}
.filter-and-sort-dialog {
	.ant-modal-body {
		padding: 0;
	}
	.ant-modal-content {
		border-radius: var(--radius-lg);
		overflow: hidden;
	}
}


/* A control's caption is never selectable — DESIGN_SYSTEM.md §9.

   Nobody copies the word on a button, but everybody drags across one, and the
   caption flashing blue in response is the interface answering a question that
   was not asked. Prose stays selectable: object names, descriptions, article
   numbers are all things a user genuinely does copy.

   Global rather than per-component, because two of the three button sources in
   this app cannot be reached from the design system: components/ui ships as a
   prebuilt bundle (only .d.ts in source), and antd's buttons are library
   markup. The hds primitives declare it for themselves through the
   unselectable mixin — this is what covers the rest.

   Inputs are exempted explicitly: user-select inherits, and a field that
   happens to sit inside a button-like container must stay selectable. */
button,
[role="button"],
.ant-btn {
	user-select: none;
	-webkit-user-select: none;
}

button input,
button textarea,
[role="button"] input,
[role="button"] textarea {
	user-select: text;
	-webkit-user-select: text;
}

a {
	color: var(--color-secondary);
	text-decoration: none;
	display: inline;
	line-height: 20px;
	&:hover {
		color: var(--color-secondary-fill-hover);
		cursor: pointer;
	}
}

/* v4 needed ~90 lines of .ant-* overrides here for radio, checkbox, tab and
   select-option colours. All of them are colorPrimary derivations in v5 and now
   come from styles/antdTheme.ts. */

/* Form */
input[type="checkbox"] {
	width: inherit !important;
	height: inherit !important;
}

.h-checkbox input {
	display: none !important;
}

.h-sidebar{
	> div:last-of-type{
		overflow: initial
	}
	@media (max-width: 865px){
		display: flex;
		> div:first-of-type{
			display: none
		}
	}
}

/* Modal.confirm hides its icon and left-aligns its copy — layout, not colour,
   so it stays. The button styling that used to live here is now token-driven. */
.ant-modal-confirm-body-wrapper {
	.ant-modal-confirm-body {
		> .anticon {
			display: none;
		}
		.ant-modal-confirm-content,
		.ant-modal-confirm-title {
			margin-left: 0 !important;
		}
	}
}

/* The OK button of a destructive confirmation. §1 lists --color-danger as
   "error borders and error helper text" — a border and a text colour, never a
   fill — so antd's "danger" prop is not usable here: on the confirm dialog's
   primary OK button it paints a solid red. This is the default white button
   wearing the danger colour instead, the same treatment sweetalert2 gets from
   .swal-danger in styles/index.css and editPanelUi's DangerButton.

   Qualified by the button row for specificity, not for scope: antd v5 injects
   its component CSS at runtime, so a bare .ant-btn.confirm-danger would be a
   coin toss against .ant-btn-primary:not(:disabled):hover. */
.ant-modal-confirm-btns .ant-btn.confirm-danger {
	background: var(--color-surface);
	border-color: var(--color-danger);
	color: var(--color-danger);
	box-shadow: none;
}

.ant-modal-confirm-btns .ant-btn.confirm-danger:hover,
.ant-modal-confirm-btns .ant-btn.confirm-danger:active,
.ant-modal-confirm-btns .ant-btn.confirm-danger:focus {
	background: var(--color-hover-ground);
	border-color: var(--color-danger);
	color: var(--color-danger);
}

`;
